export enum HttpPaths {

  // News


  GET_MEDIA_AS_BASE64 = '/api/v1/news-image/get-news-image?id=',
  GET_IMPORTANT_NEWS = '/api/v1/news/get-important-news',
  GET_ALL_NEWS = '/api/v1/news/get-news',
  GET_NEWS_by_id = '/api/v1/news/get-news-by-id',
  GET_LATEST_NEWS = '/api/v1/news/get-latest-news',
  GET_CATEGORIES = '/api/v1/news-categories/get-categories',




  // Job Announcement

  GET_JOB_ANNOUNCEMENT = '/api/v1/job-announcement/get-job-announcement',

   // Services

   GET_SERVICES = '/api/v1/service/get-services',

    // Info

    GET_Info = '/api/v1/apa-info/get-current-apa-info',

     // Subscriber

     ADD_SUBSCRIBER = '/api/v1/subscriber/subscribe',

      // CurrentHead

    GET_ALL_HEAD = '/api/v1/president/get-presidents',
    GET_CURRENT_HEAD = '/api/v1/president/get-current-president',
    GET_second_HEAD = '/api/v1/secretary-general/get-current-secretary-general',
    GET_HEAD_BY_ID = '/api/v1/president/get-president-by-id',
    //contactInfo
    GET_SOCIAL_LINKS = '/api/v1/social-media/get-social-media?pageIndex=1&pageSize=10',
    GET_BRANCHES = '/api/v1/branch/get-branches?pageIndex=1&pageSize=10',
}
